import {useTranslation} from 'react-i18next'
import {useAppDispatch, useAppSelector} from '../../../../../redux/hooks'
import './RowFilter.scss'
import {Selection} from '../../../../../components/Selection'
import {filterSelector, setFilterConfigFile} from '../../../../../redux/slices/filterSlices'
import {TRowFilter} from '../../../../../components/Table/Table'

export const RowFilter = (props: any) => {
  const {t} = useTranslation()
  const {filterConfigFile: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()

  const handleFilterChange = (value: Partial<typeof filter>) => {
    dispatch(setFilterConfigFile({...filter, ...value}))
  }

  return (
    <TRowFilter>
      <td>
        <div>&nbsp;</div>
      </td>
      <td>
        <Selection
          placeholder={t('Type')}
          data={props.types}
          value={filter?.type ?? ''}
          onChange={(type) => handleFilterChange({type})}
        />
      </td>
      <td>
      <Selection
          placeholder={t('Sales Org')}
          data={props.sales_org}
          value={filter?.sales_org_code ?? ''}
          onChange={(sales_org_code) => handleFilterChange({sales_org_code})}
        />
      </td>
      <td></td>
     <td></td>
    </TRowFilter>
  )
}
